<template>
  <div class="container-fluid container-with-vertical-nav full-height container-table">
    <div v-if="$apollo.loading">
      <div style="margin-top: 10%;" class="text-center">
        <div class="spinner" />
        <strong>กำลังโหลด..</strong>
      </div>
    </div>
    <div v-else>
      <data-table :data="groups" :columns="columns" :filters="filters" name="หน่วยงาน" create-link="/settings/groups/create">
        <div slot="toolbar-button">
          <router-link class="btn btn-primary" to="/settings/groups/create">สร้างหน่วยงาน</router-link>
        </div>

        <template slot="thead">
          <tr>
            <th width="30">#</th>
            <th>ชื่อหน่วยงาน</th>
            <th width="130">ประเภท</th>
            <th>การกระทำ</th>
          </tr>
        </template>
      </data-table>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import DataTable from '../../../components/shared/DataTable'

export default {
  components: {
    DataTable
  },
  apollo: {
    groups: gql`{
      groups {
        _id
        name
        type
      }
    }`
  },
  data () {
    return {
      filters: [
        { key: 'name', text: 'ชื่อหน่วยงาน' },
        { key: 'type', text: 'ประเภท' }
      ],
      columns: [
        {
          data: null,
          render: (data, type, row, meta) => {
            return meta.row + 1
          }
        },
        {
          data: 'name'
        },
        {
          data: 'type'
        },
        {
          data: null,
          className: 'table-view-pf-actions text-center text-nowrap',
          render: function (data, type, row, meta) {
            // Inline action button renderer
            return `<div class="table-view-pf-btn"><a href="/settings/groups/${row._id}" class="btn btn-default">ดูข้อมูล</a></div>`
          }
        }
      ]
    }
  }
}
</script>
<style lang="sass" scoped>
//
</style>



// WEBPACK FOOTER //
// src/js/views/settings/groups/Index.vue